import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import logoWithText from '../../images/logo-with-text.svg';
import logoWithoutText from '../../images/logo-without-text.svg';
import useMediaQuery from '../../hooks/useMediaQuery';

const PodiumLogo = ({
  icon = false,
  redirectUrl = '',
  invert = false,
  maxWidth = '128px',
  mobileMaxWidth = '96px',
}) => {
  const isMobile = useMediaQuery();

  return icon || isMobile ? (
    <LogoWithoutText href={redirectUrl}>
      <Image
        alt="Podium Logo"
        src={logoWithoutText}
        invert={invert}
        maxWidth={maxWidth}
        mobileMaxWidth={mobileMaxWidth}
      />
    </LogoWithoutText>
  ) : (
    <LogoWithText href={redirectUrl}>
      <Image
        alt="Podium Logo"
        src={logoWithText}
        maxWidth={maxWidth}
        mobileMaxWidth={mobileMaxWidth}
      />
    </LogoWithText>
  );
};

PodiumLogo.propTypes = {
  icon: PropTypes.bool,
  redirectUrl: PropTypes.string,
  invert: PropTypes.bool,
  maxWidth: PropTypes.string,
  mobileMaxWidth: PropTypes.string,
};

export const LogoWithText = styled.a`
  margin: 0 32px 48px 0;
  transition: all 200ms 200ms;
  white-space: nowrap;
  max-width: ${({ maxWidth }) => maxWidth};
  @media (max-width: 800px) {
    max-width: ${({ mobileMaxWidth }) => mobileMaxWidth};
    margin-bottom: 32px;
  }
`;

export const LogoWithoutText = styled.a`
  transition: all 200ms 200ms;
  white-space: nowrap;
`;

const Image = styled.img`
  max-width: ${({ maxWidth }) => maxWidth};
  filter: ${({ invert }) => (invert ? 'invert(100%)' : 'invert(0%)')};
  @media (max-width: 800px) {
    max-width: ${({ mobileMaxWidth }) => mobileMaxWidth};
  }
`;

export default PodiumLogo;
